import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmDialogsService } from '@app/core/services/dialog/confirm.dialog.service';
import { EnvironmentService } from '@app/core/services/environment/environment.service';
import { AlertsService } from '@app/core/services/alert/alerts.service';
import { MatSnackBar, MatSnackBarVerticalPosition, MatSnackBarDismiss } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import { interval, map, Observable, startWith, Subscription, takeWhile } from 'rxjs';
import { ServiceLocator } from "@app/core/services/service-locator/ServiceLocator";
import { ThemeService } from "@app/core/services/themes/theme.service";
import { HttpErrorResponse } from "@angular/common/http";
import { OmniServiceBaseResponse } from "@app/shared/models/basic.models";

@Component({standalone: true, template: ''})
export class BaseComponent implements OnInit {

  protected _alert: AlertsService;
  protected _confirmSvc: ConfirmDialogsService;
  protected _snackBar: MatSnackBar;
  protected _ngZone: NgZone;

  protected _routerSvc: Router;
  protected _envSvc: EnvironmentService;

  protected themeSvc: ThemeService;

  public busy?: Subscription | null;

  dialogRef?: MatDialogRef<any> | null;
  dialogData: any;

  constructor() {
    this._alert = ServiceLocator.injector.get(AlertsService);
    this._confirmSvc = ServiceLocator.injector.get(ConfirmDialogsService);
    this._snackBar = ServiceLocator.injector.get(MatSnackBar);
    this.themeSvc = ServiceLocator.injector.get(ThemeService);
    this._routerSvc = ServiceLocator.injector.get(Router);
    this._envSvc = ServiceLocator.injector.get(EnvironmentService);
    this._ngZone = ServiceLocator.injector.get(NgZone);
  }

  ngOnInit() { }

  protected setTheme() {

  }

  private setStyleProps(selectedTheme : any) {
    for (const key in selectedTheme) {
      if (selectedTheme.hasOwnProperty(key)) {
        // this.themeWrapper?.style.setProperty('--color-' + key, selectedTheme[key]);
      }
    }
  }

  debugError(error: { subscribe: (arg0: () => void) => void; }) {
    error.subscribe(() => { });
  }

  /**
   *
   *
   * @param {{ subscribe: (arg0: (resp: any) => void) => void; }} error
   * @param isSnackbar
   * @param callback
   * @memberof BaseComponent
   */
  handleError(error: HttpErrorResponse, isSnackbar? : boolean, callback?: () => void) {
    const omniError = error?.error as OmniServiceBaseResponse | null;

    const statusCode = omniError?.statusCode ?? error.status;
    let errorMessage = omniError?.error?.errorMessage ?? error.message;

    // TODO() Might need later
    // if (!this.handleUnauthorizedError(statusCode)) {
    //   return;
    // }

    if (statusCode === 0 || statusCode === null) {
      errorMessage = "Internet connection issue. Please try again later.";
    }
    else if (statusCode === 404) {
      errorMessage = `Sorry, currently unable to connect you to the ${this._envSvc.getAppName()} service. Please try again later.`;
    }
    else if (omniError?.error?.errorCode === 0) {
      // Check for specific error codes as needed
    }

    setTimeout(() => {
      if (isSnackbar) {
        this.displayStatusSnackBar("error", errorMessage, "Close", null);
      }
      else {
        if (!!callback) {
          this._alert.create('error', errorMessage,
          {
            overlay: true,
            overlayClickToClose: true,
            showCloseButton: true,
            duration: null
          }, callback);
        }
        else {
          this._alert.create('error', errorMessage,
          {
            overlay: true,
            overlayClickToClose: true,
            showCloseButton: true,
            duration: null
          });
        }
      }
    }, 20);
  }

  /**
   *
   *
   * @param {*} error
   * @memberof BaseComponent
   */
  handleResponseError(error: any) {
    this.handleError(error);
  }

  /**
   *
   *
   * @param {number} statusCode
   * @returns {boolean}
   * @memberof BaseComponent
   */
  handleUnauthorizedError(statusCode: number): boolean {
    const proceed = true;
    if (statusCode === 401) {
      // if (this._contextSvc.isAuthorized()) {
        this.dialogRef?.close(); // TT-120195 Always need to close dialogues when redirect due to unauthorised
        this.dialogRef = null;
        this.dialogData = null;
        // if (this._envSvc.isPayStayFlavor()) {

          this._routerSvc.navigateByUrl('/login');
          return false;
        // } else {
          // const isNonCustomer = this._contextSvc.isAdmin(); // Need to check user role before logging out
          // this._authService.logout(() => {
          //   setTimeout(() => {
          //     this
          //       ._alert
          //       .create('warning', 'Session expired. Please login again.');
          //   }, 20);
          //
          //   this.ENVSVC.IS_PAYSTAY ? this._routerSvc.navigateByUrl('/login') : this._routerSvc.navigateByUrl(isNonCustomer ? '/login' : '/atlogin');
          // });
          return false;
        // }
      // }
    }
    return proceed;
  }

  /**
   *
   *
   * @param {string} message
   * @memberof BaseComponent
   */
  success(message: string) {
    this._alert.create('success', message, { duration: null });
  }

 /**
   * Utility to show a snack bar for different status states
   * @param status Status type of the snackbar
   * @param message The message to show in the snackbar
   * @param actionName The label for the snackbar action
   * @param duration Duration for how long to show the bar for
   * @param position Where to show the snackbar, top or bottom
   */
  displayStatusSnackBar(status: "success" | "error" | "info", message: string, actionName: string = 'Close',
    duration: number | null = 3000, position: MatSnackBarVerticalPosition = 'top') : [Observable<void>, Observable<MatSnackBarDismiss>] {

    let panelClasses: string[] = [];

    switch (status) {
      case "success":
        panelClasses = ["bg-success", "text-white", "font-weight-bold", "snackbar-success-button"];
        break;

      case "error":
        panelClasses = ["bg-danger", "text-white", "font-weight-bold", "snackbar-danger-button"];
        break;

      case "info":
        panelClasses = ["bg-info", "text-white", "font-weight-bold", "snackbar-info-button"];
        break;

      default:
        break;
    }

    const ref = this._snackBar.open(message, actionName, {
      duration: duration ?? undefined,
      verticalPosition: position,
      panelClass: panelClasses
    });

    return [ref.afterOpened(), ref.afterDismissed()];
 }



  /**
   *
   *
   * @param {string} message
   * @memberof BaseComponent
   */
  warning(message: string) {
    setTimeout(() => {
      this._alert.create('warning', message);
    }, 10);
  }

  /**
   * Returns true if the a string parameter matches a mobile browser regex
   */
  static mobileCheck(a: any): boolean {
    let check = false;
    if (/((android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino)|((AppleWebKit)(?!.*Safari))/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
      check = true;
    }
    return check;
  }

  /**
   *
   */
  isMobile(): boolean {
    return BaseComponent.mobileCheck(window.navigator.userAgent || window.navigator.vendor);
  }

  /**
   *
   */
  scrollToTop() {
    try {
      window.scrollTo(0, 0);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    } catch (error) { }
  }

  /**
   *
   */
  printThisPage() {
    try {
      window.print();
    } catch (error) { }
  }

  reloadPage() {
    window.location.reload();
  }

  printLogs(msg: string, payment: boolean = true) {
    if (this._envSvc.isDevMode()) {
      if (payment) {
        console.log('[Payment session countdown] ' + msg);
      } else {
        console.log('[Session countdown] ' + msg);
      }
    }
  }
}
